/**
 * Shared utilities for VisioBackgroundsGrid and the management page.
 */
import type { VisioBackground } from '@/types/visio-background.types';
import { MAX_VISIO_BACKGROUNDS } from './visio-background-configs';

/** React Query keys for visio-background list. */
export const visioBackgroundsKeys = {
  all: ['visio-backgrounds'] as const,
};

/** Quoted background name for the delete modal. */
export function formatVisioBackgroundDeleteModalItemName(
  background: VisioBackground | null | undefined,
): string | undefined {
  return background ? `l'arrière-plan « ${background.name} »` : undefined;
}

/** Company cap reached — create is disabled. */
export function isVisioBackgroundLimitReached(count: number): boolean {
  return count >= MAX_VISIO_BACKGROUNDS;
}

/** Create-button tooltip when the cap is reached. */
export function getVisioBackgroundCreateTooltip(limitReached: boolean): string | undefined {
  return limitReached ? `Maximum ${MAX_VISIO_BACKGROUNDS} arrière-plans` : undefined;
}

/** Sortable ids in current grid order. */
export function visioBackgroundItemIds(items: VisioBackground[]): string[] {
  return items.map((item) => item.id);
}
